import { merge_default_values } from '@/utils/mergeDefaultValue'
import AllIcons, {
  absolute_icon,
  close_icon,
  fixed_icon,
  relative_icon,
  static_icon,
  sticky_icon,
} from './AllIcons'
import { typography_styles } from './TypographyStyles'
import { background_styles } from './BackgroundStyles'
import { border_styles } from './BordersStyle'

//
export const position_styles = [
  {
    key: 'position',
    value: 'static',
    type: 'select_buttons',
    title: 'Position',
    style_group: 'position',
    buttons_list: [
      {
        label: 'Static',
        value: 'static',
        icon: static_icon,
        tooltip_text: `This is the default positioning value. Elements with position: static; are positioned according to the normal flow of the document. They ignore the top, right, bottom, and left properties.`,
      },
      {
        label: 'Relative',
        value: 'relative',
        icon: relative_icon,
        tooltip_text: ` Elements with position: relative; are positioned relative to their normal position in the document flow. You can use top, right, bottom, and left properties to adjust their position relative to where they would normally appear.`,
      },
      {
        label: 'Fixed',
        value: 'fixed',
        icon: fixed_icon,
        tooltip_text: `Elements with position: fixed; are positioned relative to the viewport, and they don't move when the page is scrolled. They are also removed from the normal document flow.`,
      },
      {
        label: 'Absolute',
        value: 'absolute',
        icon: absolute_icon,
        tooltip_text: ` Elements with position: absolute; are positioned relative to the nearest positioned ancestor. If there's no positioned ancestor, it's positioned relative to the initial containing block (usually the viewport). They are taken out of the normal document flow.`,
      },
      {
        label: 'Sticky',
        value: 'sticky',
        icon: sticky_icon,
        tooltip_text: `Elements with position: sticky; are initially positioned according to the normal flow, but they become "stuck" when they reach a certain scroll position on the page. You can use top, right, bottom, and left properties to specify the point at which the element becomes sticky.`,
      },
    ],
  },
  {
    key: 'right',
    title: 'Right',
    type: 'input-px',
    value: '0px',
    is_required: false,
    style_group: 'position',
  },
  {
    key: 'left',
    title: 'Left',
    type: 'input-px',
    value: '0px',
    is_required: false,
    style_group: 'position',
  },

  {
    key: 'top',
    title: 'Top',
    type: 'input-px',
    value: '0px',
    is_required: false,
    style_group: 'position',
  },

  {
    key: 'bottom',
    title: 'Bottom',
    type: 'input-px',
    value: '0px',
    is_required: false,
    style_group: 'position',
  },
  {
    key: 'z_index',
    title: 'Z Index',
    type: 'number',
    value: '',
    is_required: false,
    style_group: 'position',
  },
]

// spacing_styles_keys
export const spacing_styles_keys = [
  'margin_right',
  'margin_left',
  'margin_top',
  'margin_bottom',
  'padding_left',
  'padding_right',
  'padding_top',
  'padding_bottom',
]
// spacing_styles_keys
export const size_styles_keys = [
  'max_width',
  'max_height',
  'min_height',
  'min_width',
  'Width',
  'Height',
]

// common size
export const common_sizes_fields = [
  {
    key: 'max_width',
    title: 'Maximum width',
    type: 'px_percentage-input',
    style_group: 'size',
    value: '100%',
    is_required: false,
  },
  {
    key: 'max_height',
    title: 'Maximum Height',
    type: 'px_percentage-input',
    style_group: 'size',
    value: '',
    is_required: false,
  },
  {
    key: 'min_width',
    title: 'Minimum Width',
    type: 'px_percentage-input',
    style_group: 'size',
    value: '',
    is_required: false,
  },
  {
    key: 'min_height',
    title: 'Minimum Height',
    type: 'px_percentage-input',
    style_group: 'size',
    value: '',
    is_required: false,
  },

  {
    key: 'width',
    title: 'Width',
    type: 'px_percentage-input',
    style_group: 'size',
    value: '100%',
    is_required: false,
  },
  {
    key: 'height',
    title: 'Height',
    type: 'px_percentage-input',
    style_group: 'size',
    value: '',
    is_required: false,
  },
]

//
export const spacing_styles = [
  {
    key: 'margin_right',
    title: 'Margin right',
    type: 'input-px',
    value: 'px',
    is_required: false,
  },
  {
    key: 'margin_left',
    title: 'Margin left',
    type: 'input-px',
    value: 'px',
    is_required: false,
  },

  {
    key: 'margin_top',
    title: 'Margin  top',
    type: 'input-px',
    value: '0px',
    is_required: false,
  },

  {
    key: 'margin_bottom',
    title: 'Margin bottom',
    type: 'input-px',
    value: '0px',
    is_required: false,
  },

  {
    key: 'padding_left',
    title: 'Padding left',
    type: 'input-px',
    value: '0px',
    is_required: false,
  },
  {
    key: 'padding_right',
    title: 'Padding right',
    type: 'input-px',
    value: '0px',
    is_required: false,
  },

  {
    key: 'padding_top',
    title: 'Padding top',
    type: 'input-px',
    value: '0px',
    is_required: false,
  },

  {
    key: 'padding_bottom',
    title: 'Padding bottom',
    type: 'input-px',
    value: '0px',
    is_required: false,
  },
]

// card styles
export const common_card_styles_fields = [
  ...merge_default_values({
    all_items: [
      ...spacing_styles,
      ...common_sizes_fields,
      ...background_styles,
      ...position_styles,
    ],
    default_values_items: [
      { key: 'padding_left', value: '8px' },
      { key: 'padding_right', value: '8px' },
      { key: 'padding_top', value: '8px' },
      { key: 'padding_bottom', value: '8px' },
    ],
  }),
  ...border_styles,
  {
    key: 'box_shadow',
    default_component_key: 'shadow',
    value: '',
    type: 'shadow-picker',
    title: 'Shadow',
  },
]

// card styles
export const common_card_styles_fields2 = [
  ...merge_default_values({
    all_items: [
      ...spacing_styles,
      ...common_sizes_fields,
      ...background_styles,
      ...position_styles,
    ],
    default_values_items: [
      { key: 'background', value: '' },
      { key: 'padding_left', value: '8px' },
      { key: 'padding_right', value: '8px' },
      { key: 'padding_top', value: '8px' },
      { key: 'padding_bottom', value: '8px' },
    ],
  }),
  ...border_styles,
  {
    key: 'box_shadow',
    default_component_key: 'shadow',
    value: '',
    type: 'shadow-picker',
    title: 'Shadow',
  },
]

// card styles
export const common_card_styles_fields_2 = [
  ...common_sizes_fields,
  ...background_styles,

  ...merge_default_values({
    all_items: spacing_styles,
    default_values_items: [],
  }),
  {
    key: 'box_shadow',
    default_component_key: 'shadow',
    value: '',
    type: 'shadow-picker',
    title: 'Shadow',
  },
]
//
export const common_button_styles_fields = [
  ...merge_default_values({
    all_items: [
      ...spacing_styles,
      ...common_sizes_fields,
      ...background_styles,
      ...typography_styles,
      ...border_styles,
    ],
    default_values_items: [
      { key: 'padding_left', value: '16px' },
      { key: 'padding_right', value: '16px' },
      { key: 'padding_top', value: '8px' },
      { key: 'padding_bottom', value: '8px' },
      { key: 'padding_bottom', value: '8px' },
      { key: 'background', value: '#004327' },
      { key: 'top_left_border_radius', value: '8px' },
      { key: 'top_right_border_radius', value: '8px' },
      { key: 'bottom_left_border_radius', value: '8px' },
      { key: 'bottom_right_border_radius', value: '8px' },
      { key: 'text_size', value: '14px' },
      { key: 'text_color', value: '#ffffff' },
      { key: 'font_weight', value: '400' },
    ],
  }),

  {
    key: 'box_shadow',
    default_component_key: 'shadow',
    value: '0px 1px 2px 0px #fff',
    type: 'shadow-picker',
    title: 'Shadow',
  },
]

export const common_button_styles = [
  ...merge_default_values({
    all_items: [
      ...spacing_styles,
      ...common_sizes_fields,
      ...background_styles,
      ...typography_styles,
      ...border_styles,
    ],
    default_values_items: [
      { key: 'padding_left', value: '16px' },
      { key: 'padding_right', value: '16px' },
      { key: 'padding_top', value: '8px' },
      { key: 'padding_bottom', value: '8px' },
      { key: 'padding_bottom', value: '8px' },
      { key: 'background', value: '#004327' },
      { key: 'top_left_border_radius', value: '8px' },
      { key: 'top_right_border_radius', value: '8px' },
      { key: 'bottom_left_border_radius', value: '8px' },
      { key: 'bottom_right_border_radius', value: '8px' },
      { key: 'text_size', value: '14px' },
      { key: 'text_color', value: '#ffffff' },
      { key: 'font_weight', value: '400' },
    ],
  }),
  {
    key: 'box_shadow',
    default_component_key: 'shadow',
    value: '0px 1px 2px 0px #ffffff',
    type: 'shadow-picker',
    title: 'Shadow',
  },
]

//Image styles
export const common_image_styles = [
  ...common_sizes_fields,
  ...spacing_styles,

  ...border_styles,
  {
    key: 'object_fit',
    value: 'cover',
    type: 'select',
    title: 'Object fit',

    drop_down_values: [
      { label: 'Fill', value: 'fill' },
      { label: 'Contain', value: 'contain' },
      { label: 'Cover', value: 'cover' },
      { label: 'None', value: 'none' },
      { label: 'Scale-Down', value: 'scale-down' },
    ],
  },
]

//
export const common_icon_styles = [...common_sizes_fields]

//
export const common_animation_styles = [
  {
    key: 'scale_animation',
    value: false,
    type: 'switch',
    title: 'Scale animation',
    style_group: 'animation',
    is_show: true,
  },
  // {
  //   key: 'bg_color_animation',
  //   value: false,
  //   type: 'switch',
  //   title: 'Background color animation',
  //   style_group: 'animation',
  //   is_show: true,
  // },
]

export const common_button_links = [
  { label: 'Add New Listing', value: '/a/add-listing' },
  { label: 'Addresses', value: '/addresses' },
  { label: 'All Listings', value: '/l' },
  { label: 'Categories', value: '/lc' },
  { label: 'Checkout', value: '/checkout' },
  { label: 'Edit Profile', value: '/edit-profile' },
  { label: 'Feedback', value: '/feedback' },
  { label: 'Home', value: '/' },
  { label: 'Invite Friends', value: '/invite' },
  { label: 'My Store', value: '/a/my-account' },
  { label: 'Orders', value: '/orders' },
  { label: 'Payments', value: '/payout' },
  { label: 'Privacy Policy', value: '/p/privacy' },
  { label: 'Social Feed', value: '/social_feed' },
  { label: 'Stores I Blocked', value: '/a/blocked' },
  { label: 'Stores I Follow', value: '/a/following' },
  { label: 'Terms and Conditions', value: '/p/terms-condition' },
  { label: 'Wallet', value: '/wallet' },
]
